import { createFileRoute } from '@tanstack/react-router'
import { ChequeDetailPage } from '../../../../features/cheques/cheque-detail-page'

export const Route = createFileRoute('/_app/cheques/$chequeId/')({
  component: ChequeDetailPage,
})
